const IconLInkedin = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path d="M3.563 1.406a1.594 1.594 0 1 0 0 3.188 1.594 1.594 0 0 0 0-3.188ZM2.063 5.906A.094.094 0 0 0 1.968 6v9.75c0 .052.042.094.093.094h3a.094.094 0 0 0 .094-.094V6a.094.094 0 0 0-.093-.094h-3ZM6.938 5.906A.094.094 0 0 0 6.843 6v9.75c0 .052.042.094.093.094h3a.094.094 0 0 0 .094-.094V10.5a1.406 1.406 0 0 1 2.813 0v5.25c0 .052.042.094.094.094h3a.094.094 0 0 0 .093-.094V9.285c0-1.82-1.583-3.244-3.394-3.08-.558.052-1.11.19-1.626.411l-.98.42V6a.094.094 0 0 0-.094-.094h-3Z" />
        </svg>
    );
};

export default IconLInkedin;
